// extracted by mini-css-extract-plugin
module.exports = {"SearchCardBox":"searchpage-card_SearchCardBox__39RgE","SearchCard":"searchpage-card_SearchCard__30bcq"};